import { BaseRepository } from '../infra/base.repository'
import { ConfigService } from '../infra/config'
import type { AppNotification } from './notification'

export class NotificationsRepository extends BaseRepository<AppNotification> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.zanduApiUrl + '/' + 'notifications', token, cache)
    }

    async markRead(id: string): Promise<AppNotification> {
        const { json, statusCode, message } = await this.request.patch(this.url + '/' + id + '/read?token=' + this.resolvedToken, {})
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async markAllRead(): Promise<{ count: number }> {
        const { json, statusCode, message } = await this.request.patch(this.url + '/read-all?token=' + this.resolvedToken, {})
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    // EventSource não passa pelo Request/fetch — precisa da URL crua com o token na query string
    streamUrl(): string {
        return this.url + '/stream?token=' + this.resolvedToken
    }
}
